export default class NotesReportRequest {
    from: string;
    to: string;
}